import http from '../http'

export default {
    all() {
        return http.get('cursos-categorias')
    },

    get(categoria) {
        return http.get(`cursos-categorias/${categoria}`)
    },

    create(payload) {
        const formData = new FormData()

        Object.entries(payload).forEach(([key, value], index) => {
            formData.append(key, value)
        })

        return http.post('cursos-categorias', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    update(categoria, payload) {
        const formData = new FormData()

        Object.entries(payload).forEach(([key, value], index) => {
            formData.append(key, value)
        })

        // Necesario para subir archivos por peticion PUT
        // En caso contrario no enviara nada en el cuerpo
        // Y hacer una peticion POST
        formData.append("_method", 'PUT')

        return http.post(`cursos-categorias/${categoria}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    save({id, ...payload}) {
        return id === undefined ? this.create(payload) : this.update(id, payload)
    },
}